<div class="sticky-header">
    <div class="top-bar">
        <div class="top-bar-content">
            <div class="location">
                <img src="assets/icon/location_icon.svg" alt="">
                <span>10th Floor (Back Side), Techno One (Sandhya Techno-1), Khajaguda, Hyderabad, Telangana &ndash; 500081.</span>
            </div>

            <div class="social-icons">
                <img src="assets/icon/Facebook.svg" alt="">
                <img src="assets/icon/Instagram.svg" alt="">
                <img src="assets/icon/Twitter.svg" alt="">
            </div>
        </div>
    </div>

    <div class="main-header">
        <div class="header-content">

            <div class="logo">
               <a href="#"> <img src="assets/icon/VIRINCHI-ENGINEERING-PVT-LTD.webp" alt=""> </a>
            </div>

            <img src="assets/icon/hamburger.svg" alt="menu" class="hamburger"(click)="toggleMenu()">

            <nav [class.open]="isMenuOpen">

            <!-- Scroll to section (#navigation) -->
            <a href="#" (click)="closeMenu()">Home</a>
            <a (click)="scrollToSection('services'); closeMenu()">Services</a>
            <a (click)="navigate('approach'); closeMenu()">Approach</a>
            <a (click)="navigate('about-us'); closeMenu()">About Us</a>
            <a (click)="navigate('collaborate'); closeMenu()" class="request-quote">Request Quote</a>

        </nav>


        </div>
    </div>
</div>
